/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AppointmentStatusEnum } from './appointmentStatusEnum';
import { TreatmentTypeEnum } from './treatmentTypeEnum';


/**
 * Lightweight appointment list for the task/event create/edit appointment dropdown.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface PatientAppointment { 
    readonly id: number;
    startDate: string;
    readonly appointmentTypeName: string;
    readonly treatmentType: TreatmentTypeEnum;
    readonly appointmentStatus: AppointmentStatusEnum;
}
export namespace PatientAppointment {
}

export const PatientAppointment_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientAppointment_startDate_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientAppointment_appointmentTypeName_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientAppointment_treatmentType_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientAppointment_appointmentStatus_Validators: ValidatorFn[] =
    [  Validators.required, ];


